<template>
  <div class="login-page">
    <div class="container-768">
      <div class="pt-20">
        <h3>ページを開いています</h3>
        <p class="text-left mt-20">
          自動的に遷移しない場合、下記のリンクをクリックしてください。
        </p>
        <p class="text-left mt-20">
          <router-link :to="{name: 'home'}" class="item"
            onclick="document.getElementById('menuopen-input').checked = false"
            >
              <span>トップページへ</span>
          </router-link>
        </p>
      </div>
      <div class="container-370">
      </div>
    </div>
  </div>
</template>

<script>
import LogApi from '@/api/log'

export default {
  mounted () {
    this.redirect()
  }, 
  methods: {
    redirect () {
      LogApi.post(this.$route.params.pmcCd, this.$route.params.calledAppName)

      // ログ保存しなくても操作はアプリは動くかもしれないので、遷移させる
      let $ = this
      setTimeout(() => $.$router.push({name: 'home'}), 500)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/Redirect.vue